var _circle, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTennis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12 12",
    enableBackground: "new 0 0 12 12",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 6.5695,
    cy: 3.0652,
    r: 12.8611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EAE263"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2126,
    style: {
      stopColor: "#E7E061"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3882,
    style: {
      stopColor: "#DCDC5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5507,
    style: {
      stopColor: "#CBD453"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7053,
    style: {
      stopColor: "#B3C846"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8528,
    style: {
      stopColor: "#94BA35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9958,
    style: {
      stopColor: "#6EA921"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6DA820"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_2_)",
    cx: 6,
    cy: 6,
    r: 6
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M4.881,9.709c-0.277,0-0.561-0.024-0.847-0.073C3.33,9.516,2.677,9.26,2.146,8.893 c-0.598-0.413-1.013-0.95-1.198-1.553C0.464,5.765,1.459,4.082,2.259,2.729c0.466-0.788,0.998-1.705,0.732-1.918 c0,0,0.521-0.313,0.554-0.288c0.14,0.105,0.185,0.62,0.019,1.07c-0.155,0.421-0.438,0.9-0.767,1.455 C2.061,4.294,1.144,5.845,1.547,7.157c0.28,0.911,1.298,1.642,2.592,1.862C5.32,9.22,6.382,8.946,6.844,8.321 c0.688-0.932,0.683-2.042,0.679-3.218c-0.003-0.683-0.005-1.39,0.14-2.06C7.847,2.197,8.42,1.652,9.321,1.467 c0.188-0.039,0.505-0.027,0.666,0.011c0.192,0.045,0.528,0.57,0.528,0.57c-0.004-0.001-0.56-0.075-1.084,0.036 C8.783,2.222,8.404,2.579,8.275,3.176C8.144,3.779,8.146,4.421,8.149,5.101c0.005,1.226,0.009,2.494-0.802,3.592 C7.032,9.12,6.532,9.43,5.902,9.588C5.583,9.669,5.238,9.709,4.881,9.709z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DBDBDB",
    d: "M9.88,2.041c0.349-0.018,0.629,0.019,0.635,0.02c-0.181-0.207-0.376-0.401-0.584-0.581 C9.824,1.463,9.679,1.454,9.543,1.458C9.666,1.646,9.778,1.84,9.88,2.041z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTennis);
export default __webpack_public_path__ + "static/media/Tennis.832ef3e77f920cff36d6ec367cd85cc0.svg";
export { ForwardRef as ReactComponent };